<div [closeOnOutSide]="isMenuOpen" (clickedOutside)="onClick()" class="relative inline-block text-left">
  <button #toggleButton title="menu" (click)="toggleMenu($event)" type="button"
    class="inline-flex justify-center w-full rounded-md border border-gray-400 shadow-sm px-4 py-1 outline-none bg-white  font-medium text-gray-700 focus:outline-none focus:border-primary"
    id="options-menu" aria-haspopup="true" aria-expanded="true">
    <fa-icon [icon]="faIconComments" class="text-gray-700"></fa-icon>
  </button>

  <!-- <pre> {{ previewLink | json }} </pre>
  <pre> {{ previewLink.join('/') }} </pre> -->

  <div title="menu" aria-orientation="vertical" *ngIf="isMenuOpen"
    class="z-50 origin-top-right absolute right-0 mt-2 w-80 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100" role="menu"
    aria-orientation="vertical" aria-labelledby="options-menu">
    <div *ngIf="previewLink.length !== 0 " class="py-2 relative">
      <div class="flex">
        <label class="block px-4 py-1  text-gray-700" role="menuitem">Liên kết bên ngoài
          <a target="_blank" [href]="previewLink.join('/')" class="block py-2 text-xs text-primary cursor-pointer">
            {{ previewLink.join('/') }}
          </a>
        </label>
      </div>
      <div class="absolute right-4 top-4">
        <a [copy-clipboard]="previewLink.join('/')" (click)="isMenuOpen = false"
          class=" md:text-xs text-white bg-gray-400 inline-block text-right cursor-pointer rounded-sm border-primary focus:shadow-outline focus:outline-none px-2 py-1 hover:bg-primary">
          Copy
        </a>
      </div>
    </div>
    <div class="py-2">
      <label class="block px-4 py-1  text-gray-700" role="menuitem"> Vui lòng đợi 5 phút để cập nhật sự thay đổi trên awread.com </label>
    </div>
    <ng-container *ngIf="book.contestNid; else btnRemove"></ng-container>
    <ng-template #btnRemove>
      <div class="py-2">
        <div (click)="chapterActionEvent.emit('delete')"
          class="outline-none block px-4 py-2 cursor-pointer text-xs text-center text-primary hover:bg-gray-100 hover:text-gray-900" role="menuitem">
          Xóa chương hiện tại
        </div>
      </div>
    </ng-template>
  </div>
</div>